<!--案例操作说明-->
<template>
  <div class="casedescription-layer">
    <div class="btn-black">
      <el-button class="el-icon-back" @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="t-title">{{ casename }}</div>
    <div class="container">
      <div class="scrollbar">
        <div class="smtitle">案例操作说明：</div>
        <div class="smpic" v-show="scenarioName != '投研报告智能体'">
          <img src="~@imgs/case/Group_304.png" v-show="type == '1'" />
          <img src="~@imgs/case/Group_305.png" v-show="type == '2'" />
        </div>
        <div class="anliyaoqiu">
          <p>案例要求：</p>
          <!-- <p v-show="type == '1'">请你搭建一个智能客服智能体，具体要求如下：1.使用XXXX模型；2.支持语音功能；3.智能体为培训XXX岗位/方面的专家；4.支持AI自动判分；5.要求E6;7.要求H。
          </p>
          <p v-show="type == '2'">请你搭建一个工作流，具体要求如下：1.使用XXXX模型；2.支持语音功能；3.智能体为培训XXX岗位/方面的专家；4.支持AI自动判分；5.要求E6;7.要求H。</p> -->
          <p class="caseText" v-html="describtion"></p>
        </div>
        <div class="container-bb">
          <hr />
          <div class="container-title">附件下载</div>
          <div class="txt" v-if="filelist.length == 0">
            <span>无</span>
            <!-- <span class="fj">附件名称</span> -->
          </div>
          <div class="txt" v-else>
            <a class="fj" v-for="(item, index) in filelist" :key="index" @click="openfile(item)"
              style="margin-right: 15px;">
              {{ item.originalFileName }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="b-btn" @click="startCase">
      开启案例
    </div>
  </div>
</template>

<script>
import apiUser from "@/api/user";
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      scenarioName: '',
      casename: '',
      describtion: '',
      type: '1',
      casepreProcess: 0,
      filelist: [],
      HtUrl: window.HtUrl
    }
  },
  computed: {},
  watch: {},
  created () {
    this.scenarioName = sessionStorage.getItem('scenarioName')
    this.casename = sessionStorage.getItem('casename')
    this.describtion = sessionStorage.getItem('describtion')
    // this.type = this.$route.query.type
    this.type = sessionStorage.getItem('casetype')
    this.casepreProcess = this.$route.query.casepreProcess || 0
    console.log("this.type", this.type);
    this.init()

  },
  mounted () { },
  methods: {
    openfile (data) {
      window.open(this.HtUrl + data.filePath, '_blank')
    },
    init () {
      let caseno = sessionStorage.getItem('caseno')
      if(caseno){
        apiUser.GetAttachment({
          caseId: sessionStorage.getItem('caseno'),
        }).then((res) => {
          console.log("res", res);
          if (res.data) {
            this.filelist = res.data || []
          }
        });
      }
    },
    //开启案例 需判断是否有前置题要做
    startCase () {
      if (this.type == '1') {
        let scenarioName = sessionStorage.getItem('scenarioName')
        if (scenarioName == '投研报告智能体') {
          this.$router.push({ path: '/case/touyanbaogao', query: { type: this.type } })
        } else {
          if (this.casepreProcess == 0) {
            //无前置题要做 直接跳转到智能客服 
            this.$router.push({ path: '/case/zhinengkefu', query: { type: this.type } })
          } else {
            //有前置题要做，跳前置题
            this.$router.push({ path: '/case/precasestudy', query: { type: this.type } })
          }
        }
        // if (this.casepreProcess == 0) {
        //   //无前置题要做 直接跳转到智能客服 
        //   this.$router.push({ path: '/case/zhinengkefu', query: { type: this.type } })
        // } else {
        //   //有前置题要做，跳前置题
        //   this.$router.push({ path: '/case/precasestudy', query: { type: this.type } })
        // }
      } else {
        //工作流直接跳dygpt
        this.$router.push({ path: '/case/workflow', query: { type: sessionStorage.getItem('casetype'), caseno: sessionStorage.getItem('caseno') } })
      }
    }
  }
}
</script>

<style scoped lang="less">
.casedescription-layer {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-repeat: no-repeat;
  padding: 0.2rem 0;
  position: relative;

  .btn-black {
    position: absolute;
    top: 0.2rem;
    right: 0.4rem;
  }

  .t-title {
    width: 100%;
    height: 0.6rem;
    text-align: center;
    font-size: 28px;
    color: #47b3fc;
    font-weight: bold;
  }

  .container {
    padding: .2rem 0.15rem;
    border-radius: 0.25rem;
    background-color: rgba(52, 87, 135, 0.6);
    width: 13.66rem;
    height: calc(100% - 1.5rem);
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 0 25px -2px rgba(130, 180, 255, 0.2) inset;
    color: #fff;

    .scrollbar{
      height: 100%;
      overflow: auto;
      padding: 0.15rem;
      box-sizing: border-box;
    }

    .smtitle {
      margin-bottom: 0.3rem;
      font-size: 22px;
      font-weight: bold;
    }

    .smpic {
      width: 100%;
      height: 4.21rem;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .anliyaoqiu {
      font-size: 16px;

      .caseText{
        border: 1px solid #fff;
        padding: 15px;
      }
    }

    .container-bb {
      .container-title {
        font-size: 16px;
        margin: 10px 0;
      }

      .txt {
        margin: 0.1rem 0;

        .fj {
          color: #7b6af6;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }

  .b-btn {
    width: 1.4rem;
    height: 0.4rem;
    line-height: 0.4rem;
    background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
    border-radius: 9px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
    margin: 30px auto 10px auto;

    &:hover {
      filter: hue-rotate(20deg) brightness(100%);
    }
  }
}

/**
 * -------------------------------------------------------
 * 滚动条
 * -------------------------------------------------------
 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 10px -2px #ffffff;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  /*background: #ddd;*/
}
</style>
